import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { CreateCustomCode, ReadCustomCode } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';
import { CustomCodeScope, customCodesQueryKey, invalidatePackagedPreviews } from './custom-codes-query-key';

export type CreateCustomCodeParams = {
  scope: CustomCodeScope;
  data: CreateCustomCode;
};

export const createCustomCode = async (
  params: CreateCustomCodeParams,
): Promise<ReadCustomCode> => {
  return await tinctApi.customCodes.createCustomCode(params.scope, params.data);
};

export const useCreateCustomCode = (
  options?: Omit<
    UseMutationOptions<ReadCustomCode, ApiError, CreateCustomCodeParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createCustomCode,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: customCodesQueryKey(args[1].scope),
      });
      invalidatePackagedPreviews(queryClient);
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
